import api from '@pray/shared/utils/api';

export type EmailHealthReport = {
  id: string;
  pdf_url: string;
  generated_by_name: string;
  created_at: string;
};

export type GetEmailHealthReportsParams = {
  orgId: string;
};

export async function getEmailHealthReports({
  orgId,
}: GetEmailHealthReportsParams): Promise<EmailHealthReport[]> {
  const url = `/web/studio/email-health/${orgId}/reports`;
  const response = await api.executeGetRequest<{ data: EmailHealthReport[] }>(url);
  return response.data.data;
}
